import { render, staticRenderFns } from "./DownloadPage.vue?vue&type=template&id=2eafef29&scoped=true&"
import script from "./DownloadPage.vue?vue&type=script&lang=js&"
export * from "./DownloadPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eafef29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eafef29')) {
      api.createRecord('2eafef29', component.options)
    } else {
      api.reload('2eafef29', component.options)
    }
    module.hot.accept("./DownloadPage.vue?vue&type=template&id=2eafef29&scoped=true&", function () {
      api.rerender('2eafef29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/DownloadPage.vue"
export default component.exports